import { UrlHelpers } from './UrlHelpers';

export const getOidcUserManager = async (login: string): Promise<Oidc.UserManager> => {
    const backUrl = window.location.origin + UrlHelpers.getUserSettingsUrl(login);

    const Oidc = await import('oidc-client' /* webpackChunkName:"oidcClient" */);
    return new Oidc.UserManager({
        authority: UrlHelpers.mediascopeAuthDomain,
        client_id: 'va-partner-yandex',
        redirect_uri: backUrl,
        post_logout_redirect_uri: backUrl,
        response_type: 'code',
        client_secret: '51f3c12b-9e51-454f-8735-efdf3e81039b',
        scope: 'openid profile'
    });
};
